export default "__VITE_ASSET__CY6LPID7__"